module.exports = __webpack_public_path__ + "media/src/img/flag_of_kyrgyzstan-486a44d726e796fad891515ed43d7dbb.svg";